<section class="table-container-comp">
  <section class="table-header-comp">
    <ng-content select="zui-table-header"></ng-content>
  </section>
  <section class="table-content-comp" (scroll)="onScroll($event)">
    <ng-content select="zui-table-content"></ng-content>
  </section>
</section>